var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E00038",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.922 9.247c0-4.096-3.323-7.417-7.422-7.417-4.1 0-7.422 3.321-7.422 7.417s3.323 7.416 7.422 7.416c4.1 0 7.422-3.32 7.422-7.416zm1.781 0c0 5.08-4.12 9.198-9.203 9.198-5.083 0-9.203-4.118-9.203-9.198S4.417.049 9.5.049c5.083 0 9.203 4.118 9.203 9.198zM7.191 8.199l3.358 3.356c.348.347.912.347 1.26 0 .348-.349.347-.913 0-1.26L8.45 6.939c-.348-.348-.912-.348-1.26 0-.347.348-.347.912.001 1.26zm3.359-1.26L7.19 10.295c-.347.347-.348.911 0 1.26.348.347.912.347 1.26 0l3.358-3.356c.348-.348.348-.912 0-1.26-.347-.348-.911-.348-1.26 0z",
    transform: "translate(-36 -563) translate(31 181) translate(5 382)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.e8305ad90e0ffb9315052fb558684bcf.svg";
export { ForwardRef as ReactComponent };